module.exports = __webpack_public_path__ + "img/logo_eureka.d4e929d4.svg";